import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api"; 

// ================= DASHBOARD =================
export const get_dashboard_index_data = createAsyncThunk(
    'dashboard/get_dashboard_index_data',
    async(userId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/home/customer/get-dashboard-data/${userId}`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// ================= PROFILE =================
export const get_customer_profile = createAsyncThunk(
    'dashboard/get_customer_profile',
    async (_, { rejectWithValue, getState }) => {
        const { token } = getState().auth;
        try {
            const { data } = await api.get('/home/customer/get-profile', {
                headers: { Authorization: `Bearer ${token}` }
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);



export const update_customer_profile = createAsyncThunk(
    'dashboard/update_customer_profile',
    async (info, { rejectWithValue, fulfillWithValue, getState }) => {
        const { token } = getState().auth;
        try {
            const { data } = await api.put(
                '/home/customer/update-profile',
                info,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const change_customer_password = createAsyncThunk(
    'dashboard/change_customer_password',
    async (passwords, { rejectWithValue, fulfillWithValue, getState }) => {
        const { token } = getState().auth;
        try {
            const { data } = await api.put(
                '/home/customer/change-password',
                passwords,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// ================= REFERRALS =================
export const get_my_referral = createAsyncThunk(
    'dashboard/get_my_referral',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/referrals/my-code');
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

export const get_my_referral_redemptions = createAsyncThunk(
    'dashboard/get_my_referral_redemptions',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/referrals/my-redemptions');
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || {});
        }
    }
);

// ================= COUPONS =================
export const get_customer_coupons = createAsyncThunk(
    'dashboard/get_customer_coupons',
    async(_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/home/customer/my-coupons', { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// ================= SLICE =================
export const dashboardReducer = createSlice({
    name: 'dashboard',
    initialState:{
        recentOrders : [], 
        totalOrder: 0,
        pendingOrder: 0,
        cancelledOrder: 0,

        profile: {},
        coupons: [],

        referralCode: null,
        referralProgram: null,
        referralRedemptions: [],
        referralTotalEarned: 0,
        referralTotalUses: 0,
        referralPendingCount: 0,

        errorMessage : '',
        successMessage: ''
    },
    reducers : {
        messageClear : (state) => {
            state.errorMessage = ""
            state.successMessage = ""
        }
    },
    extraReducers: (builder) => {
        builder
        
        // Dashboard
        .addCase(get_dashboard_index_data.fulfilled, (state, { payload }) => { 
            state.totalOrder = payload.totalOrder;
            state.pendingOrder = payload.pendingOrder;
            state.cancelledOrder = payload.cancelledOrder;
            state.recentOrders = payload.recentOrders;
        })

        // Profile
        .addCase(get_customer_profile.fulfilled, (state, { payload }) => {
            state.profile = payload.profile;
        })
        .addCase(update_customer_profile.fulfilled, (state, { payload }) => {
    state.successMessage = payload.message;
    state.profile = payload.profile;   // 🔥 refresh UI instantly
})

        .addCase(change_customer_password.fulfilled, (state, { payload }) => {
            state.successMessage = payload.message;
        })

        // Coupons
        .addCase(get_customer_coupons.fulfilled, (state, { payload }) => {
            state.coupons = payload.coupons;
        })

        // Referrals
        .addCase(get_my_referral.fulfilled, (state, { payload }) => {
            state.referralCode = payload.code;
            state.referralProgram = payload.program;
        })
        .addCase(get_my_referral_redemptions.fulfilled, (state, { payload }) => {
            state.referralRedemptions = payload.redemptions;
            state.referralTotalEarned = payload.totalEarned;
            state.referralTotalUses = payload.totalUses;
            state.referralPendingCount = payload.pendingCount;
        });
    }
});

export const { messageClear } = dashboardReducer.actions;
export default dashboardReducer.reducer;
